<script setup lang="ts">
import FullScreenLayout from '@/shared/ui/FullScreenLayout.vue'
import LoginForm from '@/features/login'
import { useAuthService } from '@/entities/auth'
import { useRoute, useRouter } from 'vue-router'
import { onBeforeMount, ref } from 'vue'
import { useAppRoutes } from '@/app/providers/app-router/useAppRoutes'

const authService = useAuthService()
const appRoutes = useAppRoutes()
const router = useRouter()
const route = useRoute()

const { mutate } = authService.refresh

const showLoginPage = ref<boolean>(false)

onBeforeMount(() => {
  mutate(undefined, {
    onSuccess: () => {
      router.push((route.query.redirect as string) || appRoutes.getTopNews())
    },
    onError: () => {
      showLoginPage.value = true
    },
  })
})
</script>

<template>
  <FullScreenLayout v-if="showLoginPage">
    <LoginForm />
  </FullScreenLayout>
</template>
